import { Checkbox, CheckboxGroup } from '@chakra-ui/checkbox';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/form-control';
import { Heading } from '@chakra-ui/layout';
import { weekdays } from 'moment';
import React from 'react';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { AdminCoursesModalForm } from '../../../../types/types';

interface AdminCoursesModalRecurrenceProps {
  form: UseFormReturn<AdminCoursesModalForm>;
}

export const AdminCoursesModalRecurrence: React.FC<AdminCoursesModalRecurrenceProps> =
  ({ form }) => {
    const { errors } = form.formState;
    const watch = useWatch({ control: form.control });

    return (
      <section>
        <Heading mb={4} size="sm">
          Kurswiederholungen
        </Heading>
        <FormControl isRequired isInvalid={!!errors.isRecurring} mb={4}>
          <Checkbox colorScheme="brand" {...form.register('isRecurring')}>
            Dieser Kurs wiederholt sich
          </Checkbox>
        </FormControl>
        {watch.isRecurring && (
          <CheckboxGroup
            colorScheme="brand"
            defaultValue={watch.daysOfWeek as string[]}
          >
            <FormControl
              isRequired
              isInvalid={!!errors.daysOfWeek}
              mb={4}
              flexWrap="wrap"
            >
              <FormLabel>An welchen Tagen findet der Kurs statt?</FormLabel>
              {weekdays(true).map((weekday, index) => (
                <Checkbox
                  key={`${weekday}-checkbox`}
                  mr={6}
                  isInvalid={!!errors.daysOfWeek}
                  value={index.toString()}
                  {...form.register(`daysOfWeek.${index}` as const, {
                    validate: () => {
                      const { daysOfWeek, isRecurring } = form.getValues();
                      if (isRecurring) {
                        if (daysOfWeek && daysOfWeek.some((v) => v !== '')) {
                          return true;
                        }
                        return false;
                      }
                      return true;
                    },
                  })}
                >
                  {weekday}
                </Checkbox>
              ))}
              <FormErrorMessage>
                {!!errors.daysOfWeek && 'Bitte wähle einen Tag aus'}
              </FormErrorMessage>
            </FormControl>
          </CheckboxGroup>
        )}
      </section>
    );
  };
